import IDateGroup from "src/components/dateselector/IDateGroup";
import { isSameDay, format } from "date-fns";
import classNames from 'classnames';
import locale from "date-fns/locale/nb";
import styles from './DateItem.module.css';

//#region [Props]
type DateItemProps = {
    month?: IDateGroup;
    date: Date;
    selectedDate: Date;
    changeDate: (date: Date) => void;
};
//#endregion

//#region [Component]
export default function DateItem({ month, date, selectedDate, changeDate }: DateItemProps) {
    const clickable = !!(month?.dates?.find((elem) => isSameDay(elem, date)));
    return (
        <button className={styles.SDateItemButton} disabled={!clickable} onClick={() => { changeDate(date) }}>
            <div className={classNames(styles.SDateDisplay, {
                [styles.clickable]: clickable,
                [styles.selected]: isSameDay(date, selectedDate)
            })}>
                {format(date, 'd', { locale })}
            </div>
        </button>
    );
}

//#endregion

//#region [Styles]
//#endregion
